module.exports = __webpack_public_path__ + "static/media/thumbnail.a858f5fc.jpg";